import React from "react";
import "./AboutUs.css";
import Image1 from "./light1.jpg";

function AboutUs() {
    return (
        <section id="about-us" className="about">
            <div className="about__container">
                <div className="section-heading">
                    <span className="section-heading__label">Who We Are</span>
                    <h2 className="section-heading__title">About Us</h2>
                    <span className="section-heading__bar"></span>
                </div>

                <div className="about__grid">
                    <div className="about__text">
                        <p className="about__paragraph">
                            Founded in 2001, Euro Light Trading is a trusted lighting supplier
                            based in Dubai, UAE. We provide high-quality lighting solutions sourced
                            from leading European and Chinese brands, carefully selected for
                            performance, design, and value.
                        </p>
                        <p className="about__paragraph">
                            Our team combines technical expertise with design insight to deliver
                            efficient, reliable, and creative lighting systems. From product supply
                            to lighting design support, we help bring every space to life with
                            the right light.
                        </p>
                        <div className="about__stats">
                            <div className="about__stat">
                                <span className="about__stat-number">20+</span>
                                <span className="about__stat-label">Years Experience</span>
                            </div>
                            <div className="about__stat">
                                <span className="about__stat-number">500+</span>
                                <span className="about__stat-label">Projects Delivered</span>
                            </div>
                            <div className="about__stat">
                                <span className="about__stat-number">100+</span>
                                <span className="about__stat-label">Trusted Clients</span>
                            </div>
                        </div>
                    </div>

                    <div className="about__image-wrapper">
                        <div className="about__image-glow"></div>
                        <img src={Image1} alt="Eurolight lighting work" className="about__image" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutUs;
